var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyProgressModel } from "survey-core";
import { SurveyNavigationBase } from "./reactSurveyNavigationBase";
import { ReactElementFactory } from "./element-factory";
var SurveyProgress = /** @class */ (function (_super) {
    __extends(SurveyProgress, _super);
    function SurveyProgress(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyProgress.prototype, "isTop", {
        get: function () {
            return this.props.isTop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyProgress.prototype, "progress", {
        get: function () {
            return this.survey.progressValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyProgress.prototype, "progressText", {
        get: function () {
            return this.survey.progressText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyProgress.prototype, "progressBarAriaLabel", {
        get: function () {
            return this.survey.progressBarAriaLabel;
        },
        enumerable: false,
        configurable: true
    });
    SurveyProgress.prototype.render = function () {
        var progressStyle = {
            width: this.progress + "%",
        };
        return (React.createElement("div", { className: this.survey.getProgressCssClasses(this.props.container) },
            React.createElement("div", { style: progressStyle, className: this.css.progressBar, role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": this.progressBarAriaLabel },
                React.createElement("span", { className: SurveyProgressModel.getProgressTextInBarCss(this.css) }, this.progressText)),
            React.createElement("span", { className: SurveyProgressModel.getProgressTextUnderBarCss(this.css) }, this.progressText)));
    };
    return SurveyProgress;
}(SurveyNavigationBase));
export { SurveyProgress };
ReactElementFactory.Instance.registerElement("sv-progress-pages", function (props) {
    return React.createElement(SurveyProgress, props);
});
ReactElementFactory.Instance.registerElement("sv-progress-questions", function (props) {
    return React.createElement(SurveyProgress, props);
});
ReactElementFactory.Instance.registerElement("sv-progress-correctquestions", function (props) {
    return React.createElement(SurveyProgress, props);
});
ReactElementFactory.Instance.registerElement("sv-progress-requiredquestions", function (props) {
    return React.createElement(SurveyProgress, props);
});
